import Vue from 'vue'
import moment from 'moment'
import store from '../store/store'
import { daysOfWeek } from '../data/options'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('momentFormat', (ms, format = 'DD.MM.YYYY') => {
  if (!ms) return 'N/A'
  const timezone = store.getters.isAuth ? store.getters.authUserCompany.timezone : 0
  return moment.unix(ms).utcOffset(timezone).format(format)
})

Vue.filter('momentRelativeTime', (ms, format = 'DD.MM.YYYY') => {
  if (!ms) return 'N/A'

  const timezone = store.getters.isAuth ? store.getters.authUserCompany.timezone : 0
  const today = moment(new Date())
  const date = moment.unix(ms).utcOffset(timezone)

  const remainDays = today.diff(date, 'days')

  if (remainDays === 0) {
    return date.format('HH:mm')
  } else if (remainDays < 8) {
    const week = date.isoWeekday()
    return daysOfWeek.find(day => week === day.value)['text']
  } else {
    return date.format(format)
  }
})

Vue.filter('messageDateAndTime', (ms) => {
  if (!ms) return 'N/A'

  let result = null

  const timezone = store.getters.isAuth ? store.getters.authUserCompany.timezone : 0

  const today = moment(new Date()).startOf('day')
  const yesterday = today.clone().subtract(1, 'days').startOf('day')
  const momentDate = moment.unix(ms).utcOffset(timezone)

  function isToday (momentDate) {
    return momentDate.isSame(today, 'd')
  }

  function isYesterday (momentDate) {
    return momentDate.isSame(yesterday, 'd')
  }

  if (isToday(momentDate)) {
    result = momentDate.format('HH:mm')
  } else if (isYesterday(momentDate)) {
    result = `Вчера в ${momentDate.format('HH:mm')}`
  } else {
    result = momentDate.format('DD.MM')
  }

  return result
})

Vue.filter('secToTime', (sec) => {
  if (!sec) return null

  const ms = sec * 1000

  let seconds = moment.duration(ms).seconds()
  let minutes = moment.duration(ms).minutes()
  let hours = Math.trunc(moment.duration(ms).asHours())

  hours = hours ? `${hours} ч. ` : ''
  minutes = minutes ? `${minutes} мин. ` : ''
  seconds = seconds ? `${seconds} сек.` : '0 сек.'

  return `${hours}${minutes}${seconds}`
})

Vue.filter('date', (date) => {
  return moment(date).format('DD.MM.YYYY')
})

Vue.filter('relativeDate', (ms) => {
  if (!ms) return 'N/A'

  const timezone = store.getters.isAuth ? store.getters.authUserCompany.timezone : 0

  const today = moment(new Date())
  const date = moment.unix(ms).utcOffset(timezone)

  const remainDays = today.diff(date, 'days')

  if (remainDays === 0) {
    const remainHours = today.diff(date, 'hours')

    if (remainHours === 0) {
      const remainMinutes = today.diff(date, 'minutes')
      if (remainMinutes < 10) {
        return 'Недавно'
      }
      return `${remainMinutes} мин. назад`
    }

    return `${remainHours} ч. назад`
  } else if (remainDays === 1) {
    return `Вчера (${date.format('DD.MM.YYYY HH:mm')})`
  } else {
    return `${date.format('DD.MM.YYYY hh:mm')}`
  }
})
